export { Iconify30 } from "./Iconify30";
